import DataManager from '@/assets/DataManager.js'
import DataFunctions from '@/assets/DataFunctions.js'
import MarkerGenerator from '@/assets/MarkerGenerator.js'
import LiveData from '@/assets/LiveData.js'

const MapOverlays = function(map, showRoadworkStart, showParkingStart) {
  var self = this;
  this.map = map;

  this.initialize = function() {
    this.dataLoading = false;

    setTimeout(() => {
      this.map.on('zoomend', () => {
  			this.checkLayers();
  		});
    }, 1000);
    //Traffic info and roadwork
    this.showTrafficInfoOnMap = showRoadworkStart || false;
    this.trafficInfoData = [];
    this.trafficSignData = [];
    this.trafficInfoLayer;
    this.trafficSignLayer;
    //Show parking at all
    this.showParkingOnMap = showParkingStart || false;
    //Parking - Car
    this.showCarParkingOnMap = true;
    this.parkingData = [];
    this.parkingLayer;
    //Parking - Bike
    this.showBikeParkingOnMap = false;
    this.bikeParkingData = [];
    this.bikeParkingLayer;

    this.checkLayers();
	},

  //Loop through layers and update
  this.checkLayers = function() {
    var zoom = this.map.getZoom();
    if(zoom >= 12) {
      (this.showTrafficInfoOnMap) ? this.showTrafficInfo() : this.removeTrafficInfo();

      if(zoom >= 15) {
        //Traffic info
        (this.showTrafficInfoOnMap) ? this.showTrafficSigns() : this.removeTrafficSigns();
        //Parking
        if(this.showParkingOnMap) {
          (this.showCarParkingOnMap) ? this.showParking() : this.removeParking();
          (this.showBikeParkingOnMap) ? this.showBikeParking() : this.removeBikeParking();
        }
        else {
          this.removeParking();
          this.removeBikeParking();
        }
      }
      else {
        this.removeParking();
        this.removeBikeParking();
        this.removeTrafficSigns();
      }

      var timeout = setInterval(() => {
        if(!this.dataLoading) {
          this.checkOpacity();
          clearInterval(timeout)
        }
      }, 200);
    }
    else {
      this.removeAllLayers();
    }
  },

  this.removeAllLayers = function() {
    this.removeTrafficInfo();
    this.removeTrafficSigns();
    this.removeParking();
    this.removeBikeParking();
  },

  //Change opacity of icons and linestring
  this.checkOpacity = function() {
    var zoom = this.map.getZoom();
    var trafficInfoSignOpacity = 0.8;
    var trafficInfoLineOpacity = 0.7;
    var parkingOpacity = 0;
    var trafficSignOpacity = 0;
    if(zoom == 12) {
      trafficInfoSignOpacity = 0;
      trafficInfoLineOpacity = 0.4;
    }
    else if(zoom == 13) {
      trafficInfoSignOpacity = 0.4;
      trafficInfoLineOpacity = 0.6;
    }
    else if(zoom == 15) {
      parkingOpacity = 0.5;
      trafficSignOpacity = 0.5;
    }
    else if(zoom > 15) {
      parkingOpacity = 0.8;
      trafficSignOpacity = 0.8;
    }
    //Traffic info
    if(this.showTrafficInfoOnMap) {
      var layers = this.trafficInfoLayer._layers;
  		for(var i in layers) {
  			if(layers[i].feature.geometry.type != 'LineString' && layers[i].feature.geometry.type != 'Polygon') {
  				layers[i].setOpacity(trafficInfoSignOpacity);
  				continue;
  			}
  			layers[i].setStyle({opacity: trafficInfoLineOpacity});
  		}

      var layers = this.trafficSignLayer._layers;
  		for(var i in layers) {
  			if(layers[i].feature.geometry.type != 'LineString' && layers[i].feature.geometry.type != 'Polygon') {
  				layers[i].setOpacity(trafficSignOpacity);
  				continue;
  			}
  			layers[i].setStyle({opacity: trafficSignOpacity});
  		}
    }

    if(this.showParkingOnMap) {
      //Parkering
      if(this.showCarParkingOnMap && zoom >= 15) {
    		var layers = this.parkingLayer._layers;
    		for(var i in layers) {
    			if(layers[i].feature.geometry.type != "LineString" && layers[i].feature.geometry.type != "Polygon") {
    				layers[i].setOpacity(parkingOpacity);
    				continue;
    			}
    			layers[i].setStyle({opacity: parkingOpacity});
    		}
      }

  		//Bike parking
      if(this.showBikeParkingOnMap && zoom >= 15) {
  			var layers = this.bikeParkingLayer._layers;
  			for(var i in layers) {
  				layers[i].setOpacity(parkingOpacity);
  			}
      }
    }
  },

  //Show/remove roadwork and traffic info layer
  this.showTrafficInfo = function() {
    if(this.trafficInfoData.length == 0) {
  		this.getTrafficInfoData();
    }
    else {
      if(!this.map.hasLayer(this.trafficInfoLayer)) {
        this.map.addLayer(this.trafficInfoLayer);
      }
    }
  },
  this.removeTrafficInfo = function() {
    if(this.map.hasLayer(this.trafficInfoLayer)) {
      this.map.removeLayer(this.trafficInfoLayer);
    }
  },

  this.showTrafficSigns = function() {
    if(!this.map.hasLayer(this.trafficSignLayer)) {
      this.map.addLayer(this.trafficSignLayer);
    }
  },
  this.removeTrafficSigns = function() {
    if(this.map.hasLayer(this.trafficSignLayer)) {
      this.map.removeLayer(this.trafficSignLayer);
    }
  },

  //Show/remove parking layer
  this.showParking = function() {
    if(this.parkingData.length == 0) {
      LiveData.getLiveData().then(() => {
        this.getParkingData();
      });
    }
    else {
      if(!this.map.hasLayer(this.parkingLayer)) {
        this.map.addLayer(this.parkingLayer);
      }
    }
  },
  this.removeParking = function() {
    if(this.map.hasLayer(this.parkingLayer)) {
      this.map.removeLayer(this.parkingLayer);
		}
  },

  //Show/remove bike parking layer
  this.showBikeParking = function() {
    if(this.bikeParkingData.length == 0) {
  		this.getBikeParkingData();
    }
    else {
      if(!this.map.hasLayer(this.bikeParkingLayer)) {
        this.map.addLayer(this.bikeParkingLayer);
      }
    }
  },
  this.removeBikeParking = function() {
    if(this.map.hasLayer(this.bikeParkingLayer)) {
      this.map.removeLayer(this.bikeParkingLayer);
		}
  },

  this.createMarkers = function(data, cityIcon) {
    let promises = [];
    for(var k in data) {
      for(var i in data[k].features) {
        if(data[k].features[i].geometry.type == 'Point') {
          let latLng = {
            lat: data[k].features[i].geometry.coordinates[1],
            lng: data[k].features[i].geometry.coordinates[0],
          }
          if(cityIcon) {
            promises.push(MarkerGenerator.generateCityDevIcon(data[k].features[i], latLng));
          }
          else {
            promises.push(MarkerGenerator.generateMarker(data[k].features[i], latLng, data[k].features[i].opacity));
          }
        }
        else if((data[k].features[i].geometry.type == 'Polygon' || data[k].features[i].geometry.type == 'LineString') && data[k].features[i].lineStyle == undefined) {
          promises.push(MarkerGenerator.getLineColors(data[k].features[i]));
        }
      }
    }

    return Promise.all(promises).then(() => {
      return data;
    });
  },

  //Prepare traffic info data
  this.getTrafficInfoData = function() {
    this.dataLoading = true;

    DataManager.getData([
      DataManager.newTags+'117-dk-light.json',
      DataManager.newTags+'115-dk-light.json',
      DataManager.newTags+'49-dk-light.json',
      DataManager.newTags+'53-dk-light.json',
      DataManager.newTags+'50-dk-light.json',
      DataManager.newTags+'16-dk-light.json',
    ], (response) => {
      var data = {
        roadInfo: response[0].data,
        roadWork: response[1].data,
  		};
      var signData = {
        oneway: response[2].data,
        roadClosure: response[3].data,
        turnRestriction: response[4].data,
        entranceRestriction: response[5].data,
  		};

      this.createMarkers(data).then(() => {
        this.prepareTrafficInfoLayer(data);
      }).then(() => {
        this.createMarkers(signData).then(() => {
          this.prepareTrafficSignLayer(signData);
        });
      });
    });
  },

  this.prepareTrafficInfoLayer = function(data) {
    //Add traffic info first
    for(var i in data['roadInfo'].features) {
      //Sort extra signs into traffic sign data so that they get shown on a higher zoom level
      this.trafficInfoData.push(data['roadInfo'].features[i]);

    }
    //Add roadwork data that is not tagged as traffic info to avoid duplicates
    for(var i in data['roadWork'].features) {
      if(!this.hasTag(117, data['roadWork'].features[i])) {
        //Sort extra signs into traffic sign data so that they get shown on a higher zoom level
        this.trafficInfoData.push(data['roadWork'].features[i]);
      }
    }
		this.trafficInfoLayer = L.geoJson(this.trafficInfoData, {
			onEachFeature: function(feature, layer) {
				MarkerGenerator.generatePopup(feature, layer, self.map);
			},
			pointToLayer: function(feature, latLng) {
        return feature.marker;
      },
			filter: function(feature) {
				var bool = MarkerGenerator.showFeature(feature);
				return bool;
			},
		  style: function(feature) {
				return feature.lineStyle;
			}
		});
  },

  this.prepareTrafficSignLayer = function(signData) {
    //Add sign data that isnt tagged as traffic info or roadwork
    for(var i in signData) {
      for(var k in signData[i].features) {
        if(!this.hasTag(117, signData[i].features[k]) && !this.hasTag(115, signData[i].features[k])) {
          this.trafficSignData.push(signData[i].features[k]);
        }
      }
    }
    this.trafficSignLayer = L.geoJson(this.trafficSignData, {
			onEachFeature: function(feature, layer) {
				MarkerGenerator.generatePopup(feature, layer, self.map);
			},
      pointToLayer: function(feature, latLng) {
        return feature.marker;
      },
			filter: function(feature) {
				var bool = MarkerGenerator.showFeature(feature);
				return bool;
			},
		});
    this.dataLoading = false;
    this.showTrafficInfo();
  },

  //Get and prepare parking data
  this.getParkingData = function() {
    this.dataLoading = true;
    DataManager.getData([
      DataManager.newTags+'51-dk-light.json',
      DataManager.newTags+'377-dk-light.json',
    ], (response) => {
      var data = {
        parking: response[0].data,
        parkingSdu: response[1].data,
  		};
      this.createMarkers(data).then(() => {
        this.prepareParkingLayer(data);
      });
    });
  },

  this.prepareParkingLayer = function(data) {
    for(var i in data) {
      for(var k in data[i].features) {
        this.parkingData.push(data[i].features[k]);
      }
    }
		this.parkingLayer = L.geoJson(this.parkingData, {
			onEachFeature: function(feature, layer) {
				MarkerGenerator.generatePopup(feature, layer, self.map);
			},
			pointToLayer: function(feature, latLng) {
        return feature.marker;
      },
      style: function(feature) {
				return feature.lineStyle;
			}
		});
    this.dataLoading = false;
    this.showParking();
	},

  //Get and prepare bike parking data
  this.getBikeParkingData = function() {
    this.dataLoading = true;
    DataManager.getData([
      DataManager.newTags+'93-dk-light.json',
    ], (response) => {
      var data = {
        bikeParking: response[0].data,
  		};
      this.createMarkers(data).then(() => {
        this.prepareBikeParkingLayer(data);
      });
    });
  },

  this.prepareBikeParkingLayer = function(data) {
    this.bikeParkingData = data['bikeParking'];
    this.bikeParkingLayer = L.geoJson(this.bikeParkingData, {
      onEachFeature: (feature, layer) => {
        MarkerGenerator.generatePopup(feature, layer, this.map);
      },
      pointToLayer: function(feature, latlng) {
        return feature.marker;
      },
    });
    this.dataLoading = false;
    this.showBikeParking();
  },

  //Sort traffic info layer
  this.sortTrafficInfo = function(networkToSortBy) {
    var sortBy = 'cyklist';
    var activeNetwork;
    if(networkToSortBy.type == 'car') {
      sortBy = 'bilist';
    }
    else if(networkToSortBy.type == 'pedestrian') {
      sortBy = 'fodgænger';
    }

    if(this.map.hasLayer(this.trafficInfoLayer)) {
      this.map.removeLayer(this.trafficInfoLayer);
    }
    if(this.map.hasLayer(this.trafficSignLayer)) {
      this.map.removeLayer(this.trafficSignLayer);
    }

    this.trafficInfoLayer = L.geoJson(this.trafficInfoData, {
			onEachFeature: function(feature, layer) {
				MarkerGenerator.generatePopup(feature, layer, self.map);
			},
			pointToLayer: function(feature, latLng) {
        return feature.marker;
      },
			filter: (feature) => {
				var bool = false;
        if(feature.properties.prop51) {
          if(feature.properties.prop51.value.toLowerCase().indexOf(sortBy) !=-1) {
            bool = true;
          }
          else {
            return false;
          }
        }
        if(feature.properties.prop90) {
          bool = this.checkIfActiveForSpecificNetwork(feature, networkToSortBy);
        }
        else {
          bool = false;
        }

				return bool;
			},
      style: function(feature) {
				return feature.lineStyle;
			}
		});

    this.trafficSignLayer = L.geoJson(this.trafficSignData, {
			onEachFeature: (feature, layer) => {
				MarkerGenerator.generatePopup(feature, layer, this.map);
			},
      pointToLayer: function(feature, latLng) {
        return feature.marker;
      },
			filter: (feature) => {
        var bool = false;

        if(feature.properties.prop51) {
          if(feature.properties.prop51.value.toLowerCase().indexOf(sortBy) !=-1) {
            bool = true;
          }
          else {
            return false;
          }
        }
        if(feature.properties.prop90) {
          bool = this.checkIfActiveForSpecificNetwork(feature, networkToSortBy);
        }
        else {
          bool = false;
        }

        return bool;
			},
		});
    this.checkLayers();
  },

  //Check if feature has given tag
  this.hasTag = function(tag, feature) {
		for(var t in feature.tags) {
			if(feature.tags[t].id == tag) {
				return true;
			}
		}
		return false;
	},

  //Check if feature is active on specific network
  this.checkIfActiveForSpecificNetwork = function(feature, network) {
    if(feature.properties.prop90) {
      var featureStartDate = new Date(feature.properties.prop90.value.from);
  		var featureEndDate = new Date(feature.properties.prop90.value.to);
      /*console.log(network.startDate);
      console.log(featureEndDate.getTime()/1000);*/
      if(network.startDate == undefined || network.endDate == undefined) {
        return true;
      }
  		if(network.startDate < featureEndDate.getTime()/1000 && network.endDate > featureStartDate.getTime()/1000) {
  			return true;
  		}
  		else {
  			return false;
  		}
    }
    else {
      return false;
    }
  },

  this.initialize();
};

export default MapOverlays;
